<template>
  <div>
    <van-uploader :after-read="afterRead" capture="camera">
      <img class="scan" :src="scanImg" />
    </van-uploader>
  </div>
</template>

<script>
import scanImg from '@/assets/image/settleAccount/icon-scan@2x.png'
import { uploadImg, policyPutUpload } from "@/services/api/uploadImg.js"

export default {
  name: 'H5Scan',
  data() {
    return {
      scanImg,
      imeiCode: ''
    }
  },
  methods: {
    async afterRead(file,name) {
      const params = {
        file: file.file,
        key: this.keyValue,
        photoIndex:name.index
      }
      let data = await this.policyPostUpload() // actionUrl,uploadData,
      let res = await this.uploadImg_http(file.file, data?.actionUrl, data?.uploadData)
      await this.scan_uploadImg(res.url)
    },
    // 获取POST上传授权
    policyPostUpload() {
      return new Promise((resolve, reject) => {
        policyPutUpload({
          realName: 'file'
        })
          .then(res => {
            if(res?.code == '0000') {
              let {
                host,
                authority,
                dir,
                policy,
                accessid,
                callback,
                signature
              } = res.data

              let actionUrl = host
              let imgName = Date.now() + '.jpg';
              let uploadData = {}
              uploadData.name = imgName
              uploadData['x-oss-object-acl'] = 'public-read'
              uploadData.key = dir + imgName
              uploadData.policy = policy
              uploadData.OSSAccessKeyId = accessid
              uploadData.success_action_status = 200
              uploadData.callback = callback
              uploadData.signature = signature
              resolve({
                actionUrl,
                uploadData,
              })
            } else{
              reject()
            }
          })
          .catch(err => {
            reject()
          })
      })
    },

    // 上传到服务器
    uploadImg_http(file, actionUrl, uploadData) {
      let formData = new FormData()
      formData.append('name', uploadData.name)
      formData.append('x-oss-object-acl', uploadData['x-oss-object-acl'])
      formData.append('key', uploadData.key)
      formData.append('policy', uploadData.policy)
      formData.append('OSSAccessKeyId', uploadData.OSSAccessKeyId)
      formData.append('success_action_status', uploadData.success_action_status)
      formData.append('callback', uploadData.callback)
      formData.append('signature', uploadData.signature)
      formData.append('file', file)
      return new Promise((resolve, reject) => {
        uploadImg(actionUrl, formData)
          .then(res => {
            if(res && res.data && res.data.code === '0000') {
              let id = res?.data?.data?.id
              let url = res?.data?.data?.url
              let obj = {
                id,
                url
              }
              resolve(obj)
            }else{
              reject()
            }
          })
          .catch(err => {
            reject()
          })
      })
    },

    // 调取识别IMEI条形码的接口
    scan_uploadImg(url) {
      const data = {
        imageUrl: url  // 'https://eswop-thail-test.oss-cn-shenzhen.aliyuncs.com/activity/1.jpg'
      }
      this.$api['scanUploadImg'](data).then(res => {
        if(res.code === '200') {
          const data = JSON.parse(res.data)
          this.imeiCode = data.imei[0]
          this.$emit('handleImei', this.imeiCode)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.scan {
  width: 20px;
  height: 20px;
}
</style>
